<template>
  <!-- 受众分析 -->
  <div class="analysisContainer" v-if="darenInfo">
      <div class="analysisPart">
        <div class="top">
          <h5>粉丝趋势</h5>
        </div>
        <div class="top_tag">
          <div class="top_tag_item">
            <span>{{darenInfo.fansIncreaseNum[daysTab]? fmt(darenInfo.fansIncreaseNum[daysTab]/100/10000,{micrometer: true}) :'-'}}w</span>
            <i>近{{daysTab ? daysTab:"-"}}天涨粉数</i>
          </div>
          <div class="top_tag_item" v-if="daysTab=='30'">
            <span>{{darenInfo.fansIncreaseRateIn30?darenInfo.fansIncreaseRateIn30:'-'}}%</span>
            <i>近30天涨粉率</i>
          </div>
          <div class="top_tag_item" v-if="daysTab=='90'">
            <span>{{darenInfo.fansIncreaseRateIn90?darenInfo.fansIncreaseRateIn90:'-'}}%</span>
            <i>近90天涨粉率</i>
          </div>
        </div>
        <el-radio-group class="tab clear" v-model="tab1Position" @change="tab1Change">
          <el-radio-button label="总量">总量</el-radio-button>
          <el-radio-button label="增量">增量</el-radio-button>
        </el-radio-group>
        <el-radio-group class="tab clear" style="margin-left: 20px" v-model="daysTab">
          <el-radio-button label="30">30天</el-radio-button>
          <el-radio-button label="90">90天</el-radio-button>
        </el-radio-group>
        <div class="center">
          <LineChart :lineChartInfo="fansNumChart.sum" ref="fansNumChartRef"></LineChart>
        </div>
      </div>
      <AudiencePortrait></AudiencePortrait>
  </div>
  <div v-else></div>
</template>

<script>
import AudiencePortrait from "../AudiencePortrait/AudiencePortrait.vue";
import LineChart from "../../../components/Echart/LineChart.vue"
import tools from "../../../components/tools/tools.js";

export default {
  name: "Analysis",
  props:["darenID"],
  data(){
    return {
      tab1Position: '总量',
      fansNumChart:{
        sum:{
          nodeId:'fansNum',//节点
          data: [],//数据
          smooth:true,//平滑
          xAxisData:[],//x轴的数据
          yAxisName:'粉丝人数',
          unit:''
        },
        add:{
          nodeId:'fansNum',//节点
          data: [],//数据
          smooth:true,//平滑
          xAxisData:[],//x轴的数据
          yAxisName:'粉丝人数',
          unit:''
        }
      },
      darenInfo:{},
      daysTab: '30',    // 30   90
    }
  },
  computed:{

  },
  methods:{
    tab1Change(tab){
      this.tab1Position=tab
      if(tab==="总量"){
        this.$refs?.fansNumChartRef?.lineChart(this.fansNumChart.sum)
      }else if(tab==="增量"){
        this.$refs?.fansNumChartRef?.lineChart(this.fansNumChart.add)
      }
    },
    async getKsPortrait(){
      let res = await this.$api.getKuaishouData.getKsPortrait('/'+this.darenID)
        if(res){
          window.sessionStorage.setItem('getKsPortrait',JSON.stringify(res));
          this.darenInfo = JSON.parse(window.sessionStorage.getItem('getKsPortrait')).data.data;
          console.log('this.darenInfo :>> ', this.darenInfo);
        }
    }
  },
  components:{
    LineChart,
    AudiencePortrait
  },
  watch:{
    daysTab(){
      let fansNumChart={
        sum:{
          nodeId:'fansNum',//节点
          data: [],//数据
          smooth:true,//平滑
          xAxisData:[],//x轴的数据
          yAxisName:'粉丝人数',
          unit:''
        },
        add:{
          nodeId:'fansNum',//节点
          data: [],//数据
          smooth:true,//平滑
          xAxisData:[],//x轴的数据
          yAxisName:'粉丝人数',
          unit:''
        }
      }
      ;(this.darenInfo.trendData[this.daysTab] || []).map(item=>{
        fansNumChart.sum.xAxisData.push(tools.setStringTime(item.label))
        fansNumChart.sum.data.push(item.value)
      })
      ;(this.darenInfo.trendDiffData[this.daysTab] || []).map(item=>{
        fansNumChart.add.xAxisData.push(tools.setStringTime(item.label))
        fansNumChart.add.data.push(item.value)
      })
      this.fansNumChart = fansNumChart
      if(this.tab1Position==="总量"){
        this.$refs?.fansNumChartRef?.lineChart(this.fansNumChart.sum)
      }else if(this.tab1Position==="增量"){
        this.$refs?.fansNumChartRef?.lineChart(this.fansNumChart.add)
      }

    }
  },
  async created(){
    // getKsFans 由父组件异步写入，原先此处同步读取且变量未使用，缓存未写入时直接抛异常导致tab空白，已移除
    let fansNumChart={
      sum:{
        nodeId:'fansNum',//节点
        data: [],//数据
        smooth:true,//平滑
        xAxisData:[],//x轴的数据
        yAxisName:'粉丝人数',
        unit:''
      },
      add:{
        nodeId:'fansNum',//节点
        data: [],//数据
        smooth:true,//平滑
        xAxisData:[],//x轴的数据
        yAxisName:'粉丝人数',
        unit:''
      }
    }

    this.darenInfo = JSON.parse(window.sessionStorage.getItem('getKsProfile') || 'null')?.data?.data || {}
    this.darenInfo.fansIncreaseNum = this.darenInfo.fansIncreaseNum || {}
    this.darenInfo.trendData = this.darenInfo.trendData || {}
    this.darenInfo.trendDiffData = this.darenInfo.trendDiffData || {}
    // await this.getKsPortrait()
    this.darenInfo.fansIncreaseNum[this.daysTab] = ((this.darenInfo.fansIncreaseNum[this.daysTab] || 0)*100).toFixed(2)
    this.darenInfo.fansIncreaseRateIn30 = ((this.darenInfo.fansIncreaseRateIn30 || 0)*100).toFixed(2)
    this.darenInfo.fansIncreaseRateIn90 = ((this.darenInfo.fansIncreaseRateIn90 || 0)*100).toFixed(2)
    ;(this.darenInfo.trendData[this.daysTab] || []).map(item=>{
      fansNumChart.sum.xAxisData.push(tools.setStringTime(item.label))
      fansNumChart.sum.data.push(item.value)
    })
    ;(this.darenInfo.trendDiffData[this.daysTab] || []).map(item=>{
      fansNumChart.add.xAxisData.push(tools.setStringTime(item.label))
      fansNumChart.add.data.push(item.value)
    })
    this.fansNumChart = fansNumChart
  },
  mounted() {
    this.$refs?.fansNumChartRef?.lineChart(this.fansNumChart.sum)
  }
}
</script>

<style scoped>
  /* 粉丝趋势折线图 */
  #fansNum{
    width: 100%;
    height: 288px;
    margin-top: 20px;
  }
  .portrait .hr{
    width: 804px;
    height: 0.5px;
    margin-top: 24px;
    margin-left: 30px;
    background: #F0F0F0;
  }
  .portrait .summary{
    border-top: 1px solid #F0F0F0;
    width: 802px;
    margin-left: 30px;
    margin-top: 24px;
  }
  .portrait .summary i{
    display: block;
    height: 70px;
    line-height: 70px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .portrait .summary span{
    margin-right: 36px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .portrait .summary span:nth-of-type(1){
    margin-left: 9px;
  }
  .analysisPart{
    width: 100%;
    padding: 0 30px 30px;
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
  }
  .analysisContainer .top{
    width: 100%;
    height: 76px;
    box-sizing: border-box;
    border-bottom: 1px solid #F0F0F0;
  }
  .analysisContainer .top h5{
    display: inline-block;
    height: 76px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .analysisContainer .top i{
    display: inline-block;
    margin-left: 10px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #999999;
  }
  .analysisContainer .top .tab{
    float: right;
    margin-left: 16px;
    margin-top: 22px;
  }
  .analysisContainer>>>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
    color: #FF5C00;
    background-color: #FFF2EB;
    border-color: #FF5C00;
    box-shadow: -1px 0 0 0 #FF5C00;
  }
  .analysisContainer>>>.el-radio-button__inner:hover{
    color: #333;
  }
  .analysisContainer>>>.el-radio-button__inner{
    padding: 10px 16px;
  }
  .analysisContainer>>>.el-radio-button:first-child .el-radio-button__inner{
    border-radius: 2px 0 0 2px;
  }
  .analysisContainer>>>.el-radio-button:last-child .el-radio-button__inner{
    border-radius: 0 2px 2px 0;
  }

  .analysisContainer .portrait>>>.el-tabs__content{
    margin-top: 0;
  }
  .analysisContainer .portrait>>>.el-tabs__nav-wrap::after{
    height: 0;
  }
  .analysisContainer .portrait>>>.el-tabs__nav-scroll{
    padding-left: 30px;
  }
  .analysisContainer .portrait{
    width: 100%;
    margin-top:16px;
    background: #FFFFFF;
    border-radius: 6px;
  }
  .analysisContainer .portrait>>>.el-tabs__item{
    line-height:74px;
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .analysisContainer .portrait>>>.el-tabs__active-bar{
    background:transparent!important;
  }
  .analysisContainer .top_tag{
    margin: 20px 0;
  }
  .analysisContainer .top_tag .top_tag_item{
    width: 160px;
    height: 50px;
    opacity: 1;
    background: #f5f7f9;
    border-radius: 4px;
    margin: 0 12px 0 0;
    padding: 14px 0 14px 24px;
    display: inline-block;
  }
  .analysisContainer .top_tag .top_tag_item span{
    display: block;
    font-size: 24px;
    font-weight: 700;
    text-align: left;
    color: #434445;
    line-height: 24px;
    margin: 0 0 8px;
  }
  .analysisContainer .top_tag .top_tag_item i{
    display: block;
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    color: #434343;
    line-height: 20px;
  }
</style>